export default "__VITE_ASSET__Chxe7lWX__"